import { Component, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { PageTemplateTable } from '../../../../../directives/page-template-table/page-template-table';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SimpleService } from '../../../../../services/api-appointment/simple/simple.service';
import { SpinnerService } from '../../../../../services/spinner/spinner.service';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpErrorResponse } from '@angular/common/http';
import { SimpleRequestSearch, SimpleAppointmentStatus } from '../../../../../models/api-appointment/simple/simple.request.model';
import { CalendarView, CalendarEvent, DAYS_OF_WEEK, CalendarDateFormatter } from 'angular-calendar';
import { Subject } from 'rxjs';
import { isSameMonth } from 'date-fns';
import { CustomDateFormatter } from '../../../../../services/utils-folder/custom-date-formatter';
import { SimpleResponse } from '../../../../../models/api-appointment/simple/simple.response.model';
import { AppointmentCalendarViewComponent } from '../appointment-calendar-view/appointment-calendar-view.component';
import { StoreRequestSearch } from '../../../../../models/api-store/store/store.request.model';
import { StoreService } from '../../../../../services/api-store/store/store.service';
import { DIALOG_MEDIUM_CONFIG } from '../../../../../utils/config/modal-settings';
import { TRUE } from '../../../../../utils/config/const';

const colors: any = {
  red: {
    primary: '#CD0000',
  },
  blue: {
    primary: 'rgb(0,0,255)',
  },
  yellow: {
    primary: 'rgb(253, 196, 0)',
  },
  green: {
    primary: 'rgb(0,128,0)',
  },
};

@Component({
  selector: 'app-appointment-calendar',
  templateUrl: './appointment-calendar.component.html',
  styleUrls: ['./appointment-calendar.component.css'],
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter,
    },
  ],
})
export class AppointmentCalendarComponent extends PageTemplateTable implements OnDestroy, AfterViewInit {

  searchFilterForm: FormGroup;
  storeCity = '';
  isTargetMailList: boolean = false;
  status = [];
  storeAddress = '';
  request: any = {};
  statusSettings = {};
  locale: string = 'it';
  view: CalendarView = CalendarView.Week;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  weekStartsOn: number = DAYS_OF_WEEK.MONDAY;
  refresh: Subject<any> = new Subject();
  events: any[];
  activeDayIsOpen: boolean = false;
  @ViewChild('autoComplete') autoComplete;


  constructor(
    private simpleService: SimpleService,
    private spinner: SpinnerService,
    private fb: FormBuilder,
    private router: Router,
    public modalService: NgbModal,
    private storeService: StoreService
  ) {
    super(modalService);
    this.searchFilterForm = this.fb.group({
      searchOldValue: '',
      searchFilterField: '',
      searchFilterField_completedOldValue: '',
      searchFilterField_completed: '',
      searchFilterField_reservedOldValue: '',
      searchFilterField_reserved: '',
      searchFilterField_reservedCheck: false,
      searchFilterField_completedCheck: false,
      searchFilterField_pendingCheck: false,
      searchFilterField_cancelledCheck: false,
    });
  }

  /**
* Inizializza la tabella
*/
  initCalendar() {
    this.spinner.show();
    let simpleRequestSearch = this.getFilter();
    this.simpleService.search(simpleRequestSearch).subscribe(
      (response) => {
        this.setCalendarEvents(response);
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      }
    );
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  filterReserved() {
    this.searchFilterForm.controls.searchFilterField_reservedOldValue.setValue(this.searchFilterForm.controls.searchFilterField_reserved.value);
    this.resetFilter();
    this.initCalendar();
  }

  filterCompleted() {
    this.searchFilterForm.controls.searchFilterField_completedOldValue.setValue(this.searchFilterForm.controls.searchFilterField_completed.value);
    this.resetFilter();
    this.initCalendar();
  }


  toggleCheckBoxes(elementToToggle) {
    let value = this.searchFilterForm.controls[elementToToggle].value
    this.searchFilterForm.controls[elementToToggle].setValue(!value);
    let listOfCheckboxes = document.getElementsByName('checkboxFilter') as any;
    listOfCheckboxes.forEach((item, i,) => {
      if (item.value !== elementToToggle && item.checked == TRUE) {
        item.checked = false
        this.searchFilterForm.controls[item.value].setValue(false);
      }
      if (i === listOfCheckboxes.length - 1) {
        this.changeFilter();
      }
    })


  }


  /**
   * Chiamata quando cambia un valore dei filtri
   */
  changeFilter() {
    this.searchFilterForm.controls.searchFilterField.setValue(this.searchFilterForm.controls.searchOldValue.value);
    this.searchFilterForm.controls.searchFilterField_reserved.setValue(this.searchFilterForm.controls.searchFilterField_reservedOldValue.value);
    this.searchFilterForm.controls.searchFilterField_completed.setValue(this.searchFilterForm.controls.searchFilterField_completedOldValue.value);
    this.resetFilter();
    this.initCalendar();
  }


  /**
   * Prende i filtri
   * @returns 
   */
  getFilter() {
    let simpleRequestSearch = new SimpleRequestSearch();
    // AutoComplete
    simpleRequestSearch.storeId = this.storeSelected[0].id;
    // Page Number
    simpleRequestSearch.pageNumber = this.numeroPagina;
    // Page Size
    simpleRequestSearch.pageSize = this.dimPagina;
    // Date Filter
    simpleRequestSearch.appointmentDate = this.searchFilterForm.controls['searchFilterField_reserved'].value;
    simpleRequestSearch.reservationDate = this.searchFilterForm.controls['searchFilterField_completed'].value;
    // Checkboxes
    if (this.searchFilterForm.controls['searchFilterField_completedCheck'].value == TRUE) {
      simpleRequestSearch.appointmentStatus = SimpleAppointmentStatus.COMPLETED;
    }
    if (this.searchFilterForm.controls['searchFilterField_reservedCheck'].value == TRUE) {
      simpleRequestSearch.appointmentStatus = SimpleAppointmentStatus.CONFIRMED;
    }
    if (this.searchFilterForm.controls['searchFilterField_pendingCheck'].value == TRUE) {
      simpleRequestSearch.appointmentStatus = SimpleAppointmentStatus.PENDING;
    }
    if (this.searchFilterForm.controls['searchFilterField_cancelledCheck'].value == TRUE) {
      simpleRequestSearch.appointmentStatus = SimpleAppointmentStatus.CANCELLED;
    }
    return simpleRequestSearch;
  }

  clickButtonClearFilter() {
    // AutoComplete Input
    this.autoComplete.clear();
    // Date
    this.searchFilterForm.controls.searchFilterField_reserved.setValue('');
    this.searchFilterForm.controls.searchFilterField_completed.setValue('');
    // Checkboxes
    let listOfCheckboxes = document.getElementsByName('checkboxFilter') as any;
    listOfCheckboxes.forEach((item, i,) => {
      if (item.checked == TRUE) {
        item.checked = false
        this.searchFilterForm.controls[item.value].setValue(false);
      }
    })
  }


  clickButtonUpdate(id) {
    const url = 'appointment/appointment/' + id;
    this.router.navigate([url], { queryParams: { history: true }, queryParamsHandling: 'preserve' });
  }


  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      this.activeDayIsOpen = false;
      this.viewDate = date;
    }
  }

  handleEvent(action: string, event: CalendarEvent): void {
    if (action === "weekClick") {
      this.openDialog(event);
    }
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  openDialog(item) {
    this.spinner.show();
    const modalRef = this.modalService.open(AppointmentCalendarViewComponent, DIALOG_MEDIUM_CONFIG);
    modalRef.componentInstance.title = item.title;
    modalRef.componentInstance.id = item.id;
    modalRef.componentInstance.date = item.date;
    modalRef.componentInstance.color = item.color;
    modalRef.result.then((result: SimpleResponse) => {
      if (result) {
        this.initCalendar();
      }
    });
  }

  setCalendarEvents(response) {
    let data = response.data;
    if (data.length > 0) {
      this.events = [];
      data.forEach((element, index, array) => {
        if (element) {
          let dateObject = new Date(element.appointmentDate);
          this.events.push({
            start: dateObject,
            end: dateObject,
            date: element.appointmentDate,
            title: element.topicTitle,
            id: element.id,
            color: this.getColor(element),
          })
        }
        if (array.length - 1 == index) {
          this.refresh.next();
        }
      });
    } else {
      this.events = [];
      this.refresh.next();
    }
  }
  getColor(element) {
    switch (element.appointmentStatus) {
      case 'PENDING':
        return colors.yellow
      case 'CANCELLED':
        return colors.red
      case 'CONFIRMED':
        return colors.blue
      case 'COMPLETED':
        return colors.green
    }
  }

  goToList() {
    const url = 'appointment/appointment';
    this.router.navigate([url], { queryParams: { history: true }, queryParamsHandling: 'preserve' });
  }

  //Autocomplete Stores
  storeKeyword = 'titleSeo';
  storesSuggestion: any = [];
  storeSelected: any = [];
  errorMsg = 'Nessuno Store trovato!';
  isStoreKeywordLoadingResult: boolean;
  fillstoresSuggestion(response){
    if (response != null && typeof response != typeof undefined) {
      for (let obj of response.data) {
        let finded = false;

        for (let storeSelect of this.storeSelected) {
          if (obj.id == storeSelect.id) {
            finded = true;
            break;
          }
        }

        if (!finded) {
          this.storesSuggestion.push(obj);
        }
      }
    }
  }
  getStoresList(event) {
    if (event.length > 3) {
      this.isStoreKeywordLoadingResult = true;
      let request = new StoreRequestSearch();
      request.q = event;
      request.pageNumber = 0
      request.pageSize = 20
      this.storeService.search(request).subscribe(response => {
        this.storesSuggestion = [];
        this.fillstoresSuggestion(response);
        this.isStoreKeywordLoadingResult = false;
      });
    }
  }

  searchStoreCleared() {
    this.storesSuggestion = [];
    this.storeSelected = [];
    this.events = [];
    this.refresh.next();

  }

  selectStoreEvent(item) {
    this.storeSelected.push(item);
    this.initCalendar();
  }

  onChangeSearch(val: string) {
    console.log(val);
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }

  onStoreFocused(e) {
    console.log(e);
    // do something when input is focused
  }

}
